var _defs, _path, _polygon, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilettesMauvaisePosition2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\\xE9paration_toilettes",
    "data-name": "r\\xE9paration toilettes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 672.03 630.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "toilettes mauvaise r\xE9ponse 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M983.76,1315.31V1198.18c-89-7.48-108.74-59-109.61-122.51h228.9v-245H1253.5v484.66Z",
    transform: "translate(-581.47 -715.19)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "504.39 362.63 504.39 127.28 521.58 156.65 521.58 361.55 504.39 362.63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660,1316c-4,31-58,48-58-21,0,0,9-141,13-180-5-49-26.5-158-30-194-3-30.39,3.65-88,90.38-105.65l162.48-38.51c69.23-4.22,65.32,78.71,76.51,126.26l65.84,191.31c2.09,25.8-25.55,42.66-43.31,25.17L835.12,913.35S700.76,916.94,698,928c8,56,5.46,115.81,0,174C695,1134,660,1316,660,1316Z",
    transform: "translate(-581.47 -715.19)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 398.73,
    cy: 79.02,
    r: 79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilettesMauvaisePosition2);
export default __webpack_public_path__ + "static/media/toilettes_mauvaise_position_2.8fb6e34c82fc163697ae2ca9e74638b1.svg";
export { ForwardRef as ReactComponent };